import { FetcherAmplify } from 'src/business/Libraries/Fetcher/FetcherAmplify';
import QuizRepositoryI from './QuizRepositoryI';

export default class QuizRepositoryImpl implements QuizRepositoryI {
  constructor(private fetcher: FetcherAmplify) {}

  public async create(customerId: string): Promise<any> {
    return this.fetcher.post(`/v1/customers/${customerId}/quizzes`, {
      queryStringParameters: {
        customerType: 'BUSINESS',
      },
    });
  }

  public async update(
    customerId: string,
    idQuiz: string,
    questions: any[],
  ): Promise<any> {
    return this.fetcher.put(`/v1/customers/${customerId}/quizzes/${idQuiz}`, {
      body: {
        questions,
      },
    });
  }

  public async getQuiz(customerId: string): Promise<any> {
    return this.fetcher.get(`/v1/customers/${customerId}/quizzes`, {
      queryStringParameters: {
        getLastCompletedQuizz: true,
      },
    });
  }
}
